import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { GetIVReimbursementById } from "./slice"
import { ReimbursementTypeEnum } from "./dataservice/dto"
import { InfoBox } from "../../../../../ui/molecules/infoBox"
import { CarTypeOptions, formatterDate, optionsFormatter, PaymentTypeOptions, ReimbursementTypeOptions, UsedVehicleOptions } from "../../../../../utils"

interface Props {
    reimbursementId: string
    close: () => void
}

export function GestioneRimborsiViewPopup(props: Props) {
    const dispatch = useAppDispatch()
    const reimbursementState = useAppSelector(state => state.reimbursement)

    useEffect(() => {
        dispatch(GetIVReimbursementById(props.reimbursementId))
    }, [])

    if (reimbursementState.getReimbursementByIdResponse?.reimbursementType === ReimbursementTypeEnum.INDENNITA_CHILOMETRICA)
        return (
            <div style={{ padding: '24px' }}>
                <div>
                    <div className="pb-5">
                        <InfoBox
                            color="green"
                            title="Informazioni Automobile"
                            content={[
                                { title: 'Modello Auto', label: reimbursementState.getReimbursementByIdResponse?.carModel ?? '' },
                                { title: 'Targa Auto', label: reimbursementState.getReimbursementByIdResponse?.carNumberPlate ?? '' },
                                { title: 'Tipologia Auto', label: optionsFormatter(reimbursementState.getReimbursementByIdResponse?.carType!, CarTypeOptions) ?? '' }
                            ]}
                        />
                    </div>
                    <div>
                        <InfoBox
                            color="green"
                            title="Altre Informazioni"
                            content={[
                                { title: 'Tipologia Rimborso', label: optionsFormatter(reimbursementState.getReimbursementByIdResponse?.reimbursementType!, ReimbursementTypeOptions) ?? '' },
                                { title: 'Giorno', label: formatterDate(reimbursementState.getReimbursementByIdResponse?.day) ?? '' },
                                { title: 'Luogo di partenza', label: reimbursementState.getReimbursementByIdResponse?.departurePlace ?? '' },
                                { title: 'Luogo di arrivo', label: reimbursementState.getReimbursementByIdResponse?.arrivalPlace ?? '' },
                                { title: 'Luogo di ritorno', label: reimbursementState.getReimbursementByIdResponse?.returnPlace ?? '' },
                                { title: 'Km percorsi', label: String(reimbursementState.getReimbursementByIdResponse?.kilometresTravelled) ?? '' },
                                { title: 'Note', label: String(reimbursementState.getReimbursementByIdResponse?.note) ?? '' },
                            ]}
                        />
                    </div>
                </div>
            </div>
        )

    return (
        <div style={{ padding: '24px' }}>
            <InfoBox
                color="green"
                title="Informazioni Generali"
                content={[
                    { title: 'Tipologia Rimborso', label: optionsFormatter(reimbursementState.getReimbursementByIdResponse?.reimbursementType!, ReimbursementTypeOptions) ?? '' },
                    { title: 'Importo', label: String(reimbursementState.getReimbursementByIdResponse?.amount) ?? '' },
                    { title: 'Tipo di pagamento', label: optionsFormatter(reimbursementState.getReimbursementByIdResponse?.paymentType!, PaymentTypeOptions) ?? '' },
                    { title: 'Mezzo Usato', label: optionsFormatter(reimbursementState.getReimbursementByIdResponse?.usedVehicle!, UsedVehicleOptions) ?? '' },
                    { title: 'Note', label: String(reimbursementState.getReimbursementByIdResponse?.note) ?? '' }
                ]}
            />
        </div>
    )
}